module.exports = __webpack_public_path__ + "img/top_woman.6636dc16.svg";